import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Fatima Sheikh",
      age: 28,
      treatment: "Composite Filling",
      rating: 5,
      review: "Dr. Muhammad Junaid is an excellent dentist! My tooth-colored fillings look so natural, you can't even tell I had cavities. The treatment was painless and the clinic is very clean and professional.",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b390?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      beforeAfter: "My cavities are completely filled and my teeth look perfectly natural. No more tooth pain!",
      duration: "1 visit"
    },
    {
      id: 2,
      name: "Ahmed Hassan",
      age: 35,
      treatment: "Root Canal Therapy",
      rating: 5,
      review: "Amazing experience! Dr. Muhammad Junaid and his team made me feel so comfortable during my root canal treatment. The procedure was painless and the results were excellent. The modern equipment and professional care made all the difference. Highly recommend Prime Care Dental!",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
              beforeAfter: "My infected tooth is now completely healthy and pain-free. Dr. Muhammad Junaid saved my tooth!",
      duration: "3 visits"
    },
    {
      id: 3,
      name: "Ayesha Khan",
      age: 22,
      treatment: "Orthodontics",
      rating: 5,
      review: "I got braces at Prime Care Dental and the results are amazing! Dr. Muhammad Junaid explained everything clearly and the staff was always helpful. My crooked teeth are now perfectly straight!",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      beforeAfter: "From crooked teeth to a perfect smile - this transformation changed my confidence completely!",
      duration: "20 months"
    },
    {
      id: 4,
      name: "Muhammad Ali",
      age: 42,
      treatment: "Dental Implant",
      rating: 5,
      review: "Lost a tooth in an accident and Dr. Muhammad Junaid recommended dental implant. The process was smooth and now I have a tooth that looks and feels completely natural. Excellent work!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      beforeAfter: "My missing tooth is replaced with an implant that looks and functions like a natural tooth!",
      duration: "4 months"
    },
    {
      id: 5,
      name: "Sana Malik",
      age: 26,
      treatment: "Scaling and Polishing",
      rating: 5,
      review: "Regular cleaning at Prime Care Dental keeps my teeth healthy and bright. The hygienist is gentle and thorough, and Dr. Muhammad Junaid always checks to make sure everything is perfect.",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      beforeAfter: "My teeth are now sparkling clean and my gums are healthy. No more plaque buildup!",
      duration: "1 session"
    },
    {
      id: 6,
      name: "Usman Tariq",
      age: 31,
      treatment: "Teeth Whitening",
      rating: 5,
      review: "Professional teeth whitening at Prime Care Dental gave me the bright white smile I always wanted. Dr. Muhammad Junaid's technique is safe and effective. Very happy with the results!",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      beforeAfter: "My teeth are now several shades whiter and I smile with confidence everywhere I go!",
      duration: "2 sessions"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <svg
        key={index}
        className={`star ${index < rating ? 'filled' : ''}`}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 2L15.09 8.26L22 9L16 14.74L17.18 21.02L12 18.77L6.82 21.02L8 14.74L2 9L8.91 8.26L12 2Z"/>
      </svg>
    ));
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="testimonials-container">
        {/* Header */}
        <div className="testimonials-header">
          <div className="testimonials-badge">
            <svg className="badge-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            <span>Patient Reviews</span>
          </div>
          
          <h2 className="testimonials-title">
            What Our Patients 
            <span className="title-highlight"> Say About Us</span>
          </h2>
          
          <p className="testimonials-description">
            Read real experiences from patients who have transformed their smiles with our expert orthodontic care. 
            Their stories speak to our commitment to excellence and patient satisfaction.
          </p>
        </div>

        {/* Statistics */}
        <div className="testimonials-stats">
          <div className="stat-item">
            <div className="stat-number">4.9</div>
            <div className="stat-stars">
              {renderStars(5)}
            </div>
            <div className="stat-label">Average Rating</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">500+</div>
            <div className="stat-label">Happy Patients</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">98%</div>
            <div className="stat-label">Satisfaction Rate</div>
          </div>
        </div>

        {/* Testimonials Swiper */}
        <div className="testimonials-swiper-container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              nextEl: '.testimonials-next',
              prevEl: '.testimonials-prev',
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            effect="coverflow"
            coverflowEffect={{
              rotate: 30,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            className="testimonials-swiper"
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <div className="testimonial-card">
                  <div className="testimonial-header">
                    <div className="patient-image">
                      <img 
                        src={testimonial.image} 
                        alt={testimonial.name}
                        className="patient-photo"
                      />
                      <div className="treatment-badge">
                        {testimonial.treatment}
                      </div>
                    </div>
                    
                    <div className="patient-info">
                      <h4 className="patient-name">{testimonial.name}</h4>
                      <div className="patient-details">
                        <span className="patient-age">Age: {testimonial.age}</span>
                        <span className="treatment-duration">Duration: {testimonial.duration}</span>
                      </div>
                      <div className="rating">
                        {renderStars(testimonial.rating)}
                      </div>
                    </div>
                  </div>

                  <div className="testimonial-content">
                    <div className="quote-icon">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z"/>
                      </svg>
                    </div>
                    
                    <p className="testimonial-text">
                      "{testimonial.review}"
                    </p>
                    
                    <div className="testimonial-result">
                      <div className="result-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                        </svg>
                      </div>
                      <p className="result-text">{testimonial.beforeAfter}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation */}
          <div className="testimonials-navigation">
            <button className="testimonials-prev">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"/>
              </svg>
            </button>
            <button className="testimonials-next">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Background Elements */}
        <div className="testimonials-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 